<template>
  <div class="fill-height">
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.smAndUp" fixed app>
      <v-slide-x-transition mode="out-in">
        <div :key="menuKey">
          <router-view name="menu"></router-view>
        </div>
      </v-slide-x-transition>
    </v-navigation-drawer>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.smAndUp"
      color="primary"
      src="/assets/bg.jpg"
      dark
      fixed
      app
      class="header-toolbar"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title class="headline">
        <v-list-item to="/">
          <v-list-item-content>
            <v-list-item-title class="headline">{{ $t("admin.header.title") }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t("admin.header.poweredBy") }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down"> </v-toolbar-items>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <lang-switcher />
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <a v-on="on" class="mt-1">
            <img height="48px" src="/assets/user.png" />
          </a>
        </template>
        <v-list dense>
          <v-list-item @click="disconnect" ripple>
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("admin.menu.signout") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-slide-x-reverse-transition mode="out-in">
        <v-container :key="pageKey" fluid>
          <router-view></router-view>
        </v-container>
      </v-slide-x-reverse-transition>
    </v-main>
  </div>
</template>

<script>
import LangSwitcher from "../../common/_langSwitcher";

export default {
  components: { LangSwitcher },
  data() {
    return {
      drawer: null,
      accounts: [],
    };
  },
  computed: {
    menuKey() {
      return this.$route.matched[1].path;
    },
    pageKey() {
      return this.$route.matched[2].path;
    },
  },
  async mounted() {},
  methods: {
    async disconnect() {
      await this.$store.dispatch("AUTHENTICATE", false);
      this.$router.push("/login");
    },
  },
};
</script>
<style>
div[class="v-data-footer__select"] {
  display: none !important;
}
</style>

<style scoped>
.snackstack {
  top: 65px;
  position: fixed;
  z-index: 1111;
  width: 100%;
}

.snackstack .v-snack {
  position: relative;
  margin-top: 6px;
}
</style>
